import axios from 'axios';
import { useMutation, useQuery } from 'react-query';
import { request, requestXlsxFileDownload, upload } from '../utils/axios-utils';

export const getPresignedUrl = async paramsObj => {
    return request({
        url: `/order/outBoundCsvUpload/${paramsObj?.companyCode}?fname=${paramsObj?.fname}`,
        method: 'GET',
    });
};

const processCsvData = (key, companyCode) => {
    return request({
        url: `/order/globalOutbound/validate?key=${key}&companyCode=${companyCode}`,
        method: 'GET',
    });
};

export const useProcessCsvData = (key, companyCode, onSuccess, onError) => {
    return useQuery([key, companyCode], () => processCsvData(key, companyCode), {
        enabled: !!key && !!companyCode,
        refetchOnWindowFocus: false,
        onSuccess: onSuccess,
        onError: onError,
    });
};

const submitSelectedData = data => {
    return request({
        url: `/order/globalOutbound/apply`,
        method: 'POST',
        data,
    });
};

export const useSubmitSelectedData = (onSuccess, onError) => {
    return useMutation(submitSelectedData, {
        onSuccess: onSuccess,
        onError: onError,
    });
};
